// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609290359/js/" + chunkId + "." + {"44":"3664213a","225":"0d18c73c","481":"eb124668","486":"e7aaa375","770":"a3e1500e"}[chunkId] + ".0.861315994097688.chunk.js";
};